'use client';

import ImageOptimizer from '@/components/image-optimizer';
import {
  PlanDto,
  PriceDto,
  TAGS_SEPARATOR,
} from '@/services/types/pricing.type';
import { PricingOption } from './pricing-option';
import { Tag } from './tag';

export default function PricingCard(plan: PlanDto) {
  return (
    <>
      <div className="desktop:rounded-2xl w-full overflow-hidden rounded-xl bg-white pb-2">
        {/* 1. 이미지 */}
        <div className="desktop:aspect-[340/181] desktop:mx-5 desktop:mt-6 desktop:rounded-2xl relative mx-5 mt-5 aspect-[287/153] rounded-xl">
          <ImageOptimizer
            src={plan.repImagePath}
            alt={plan.label + ' ' + plan.subLabel}
            fill
            className="desktop:rounded-2xl rounded-xl object-cover"
          />
        </div>

        {/* 2. 콘텐츠 */}
        <div className="desktop:pt-6 desktop:px-5 desktop:pb-3 px-4 pt-5">
          <h3 className="text-main-orange typo-26 desktop:typo-32 desktop:mb-5 mb-3 text-center font-extrabold">
            {plan.label} <span className="text-level-2">{plan.subLabel}</span>
          </h3>

          {/* 특징 태그 */}
          <div className="desktop:mb-3 mb-2 flex flex-wrap justify-center gap-2">
            {plan.tags
              ?.split(TAGS_SEPARATOR)
              .map((tag: string, index: number) => (
                <Tag key={index} label={tag} />
              ))}
          </div>

          {/* 가격표 */}
          {/* <div className="divide-stroke-white space-y-2 divide-y"> */}
          {plan.prices.map((price: PriceDto, index) => (
            <PricingOption
              key={index}
              price={price}
              showDivider={index < plan.prices.length - 1}
            />
          ))}
          {/* </div> */}
        </div>
      </div>
    </>
  );
}
